import { BasicModel } from '../basic/basic.model';
import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';
import { FamilleModel } from './famille.model';

export class ActiviteModel extends BasicModel implements BasicWithLibelleModel {
    code: string;
    libelle: string;
    // liste de famille
    familles: FamilleModel[] = [];
}

export class ActiviteNode extends BasicModel implements BasicWithLibelleModel {
    // max-length 6
    code: string;
    // max-length 30
    libelle: string;
    
    idParent: number;
    idPParent: number;
    level: number;
    type: string;

    childrens?: ActiviteNode[];

    //activite?: ActiviteModel;
}
